import Parse from "parse";

//***** Google Sheet { *****//
export const saveToSheet = async ({
  user_key,
  user_name,
  user_age,
  user_gender,
  user_place,
  action,
}) => {
  // undefined인 값은 제외하고 전송
  const params = { user_key };
  if (user_name !== undefined) params.user_name = user_name;
  if (user_age !== undefined) params.user_age = user_age;
  if (user_gender !== undefined) params.user_gender = user_gender;
  if (user_place !== undefined) params.user_place = user_place;

  return await Parse.Cloud.run(action, params);
};
//***** } Google Sheet *****//
